export default __webpack_public_path__ + "static/media/4-star.8666b6ac.png";